var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsia75(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 15,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.25 51.5515L53.75 59.6978V54.3764L66.4162 49.2915L66.2454 49.5675V48.9105L66.4162 49.1864L53.75 44.1016V38.7802L72.25 46.9265V51.5515ZM43.4998 105L54.655 82.9261V82.7422H41.6603V78.0909H60.5413V82.8079L49.373 105H43.4998ZM73.9072 105.368C72.0502 105.368 70.3946 105.026 68.9406 104.343C67.4953 103.66 66.3478 102.718 65.4981 101.518C64.6484 100.318 64.2061 98.9428 64.171 97.3924H69.6895C69.7508 98.4348 70.1888 99.2801 71.0034 99.9283C71.818 100.576 72.786 100.901 73.9072 100.901C74.8006 100.901 75.589 100.703 76.2722 100.309C76.9642 99.9064 77.5029 99.3501 77.8884 98.6406C78.2825 97.9223 78.4796 97.099 78.4796 96.1705C78.4796 95.2244 78.2782 94.3923 77.8752 93.674C77.481 92.9557 76.9336 92.3951 76.2328 91.9922C75.5321 91.5893 74.7306 91.3834 73.8283 91.3746C73.04 91.3746 72.2735 91.5367 71.529 91.8608C70.7932 92.1849 70.2194 92.6272 69.8078 93.1879L64.7492 92.2812L66.0237 78.0909H82.4739V82.7422H70.7144L70.018 89.4826H70.1756C70.6487 88.8169 71.3626 88.265 72.3173 87.8271C73.2721 87.3891 74.3408 87.1701 75.5233 87.1701C77.1438 87.1701 78.5891 87.5511 79.8592 88.3132C81.1294 89.0753 82.1323 90.122 82.8681 91.4535C83.6039 92.7762 83.9674 94.3003 83.9587 96.0259C83.9674 97.8391 83.547 99.4509 82.6973 100.861C81.8564 102.263 80.6783 103.366 79.1629 104.172C77.6562 104.969 75.9043 105.368 73.9072 105.368Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsia75);
export default __webpack_public_path__ + "static/media/Usia-75.44cec6fed0f87a07cdd5fd8b221d6f76.svg";
export { ForwardRef as ReactComponent };